import React from "react";
import styled from "styled-components";

const StyledInputWrapper = styled.div`
  position: relative;
`;

const StyledInput = styled.input`
  position: absolute;
  height: 7px;
  width: 6px;
  outline: none;
  top: 8px;
  left: 3px;
  margin: 0;

  &:checked + label {
    color: ${props => props.theme.primary};

    &:before {
      border-color: ${props => props.theme.primary};
    }

    &:after {
      opacity: 1;
    }
  }
`;

const StyledLabel = styled.label`
  transition: color 0.2s ease-in-out;
  padding-left: 20px;
  vertical-align: middle;
  color: ${props => props.theme.tertiary};
  cursor: pointer;

  &::before,
  &::after {
    border-radius: 50%;
    position: absolute;
    content: "";
  }

  &::before {
    transition: border-color 0.2s ease-in-out;
    background-color: #ffffff;
    width: 12px;
    height: 12px;
    left: 0;
    top: 4px;
    border: 1px solid ${props => props.theme.tertiary};
    z-index: 1;
  }

  &::after {
    transition: opacity 0.2s ease-in-out;
    width: 8px;
    height: 8px;
    left: 3px;
    top: 7px;
    border-radius: 50%;
    opacity: 0;
    background-color: ${props => props.theme.primary};
    z-index: 2;
  }
`;

const InputRadio = ({
  label,
  value,
  name,
  id,
  checked,
  onChange,
  className,
  ...restProps
}) => (
  <StyledInputWrapper className={className}>
    <StyledInput
      type="radio"
      name={name}
      id={id}
      value={value}
      checked={checked}
      onChange={onChange}
      {...restProps}
    />
    <StyledLabel htmlFor={id}>{label}</StyledLabel>
  </StyledInputWrapper>
);

export default InputRadio;
